import { render, staticRenderFns } from "./ApplicationInstanceViewComponent.vue?vue&type=template&id=0fe5438c&"
import script from "./ApplicationInstanceViewComponent.vue?vue&type=script&lang=js&"
export * from "./ApplicationInstanceViewComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
